<div #scrollElement class="ui-device-list" cdkScrollable>
  <div
    class="ui-device-list__spacer"
    [style.height.px]="virtualizer.getTotalSize()"
  >
    @for (virtualItem of virtualizer.getVirtualItems(); track virtualItem.key) {
      @if (itemContext(virtualItem); as context) {
        <div
          #virtualRow
          class="ui-device-list__row"
          [attr.data-index]="virtualItem.index"
          [style.transform]="'translateY(' + virtualItem.start + 'px)'"
        >
          <ng-container
            [ngTemplateOutlet]="itemTemplate()"
            [ngTemplateOutletContext]="context"
          ></ng-container>
        </div>
      }
    }
  </div>
</div>
